
const defaults = {
	id: null,
	nickname: null,
	avatar: null,
	small_avatar: null,
	has_liveroom: true,
};


export default (state=defaults, action) => {
	switch(action.type){
		case 'ACCOUNT_LOAD':
			return {...state, ...action.payload};
		case 'ACCOUNT_SET_LIVEROOM':
			return {...state, has_liveroom: action.payload};
		default:
			return state;
	}
}




// WEBPACK FOOTER //
// ./src/reducers/account.js